import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormField } from '@nuso/forms/data-access';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-divider-input',
    templateUrl: './divider-input.component.html',
    styleUrls: ['./divider-input.component.scss'],
    standalone: false
})
export class DividerInputComponent extends BaseFormInput {
  @Input() override field: FormField;

}
